import { addProvider } from '../metaData';
const VIEWPORT_V2_DATA_SET = 'genericViewportDataSet';
let state = {};
const genericViewportDataSetMetadataProvider = {
    VIEWPORT_V2_DATA_SET,
    add(dataId, dataSet) {
        state[dataId] = dataSet;
    },
    get(type, dataId) {
        if (type !== VIEWPORT_V2_DATA_SET) {
            return;
        }
        return state[dataId];
    },
    remove(dataId) {
        delete state[dataId];
    },
    clear() {
        state = {};
    },
};
addProvider(genericViewportDataSetMetadataProvider.get);
export default genericViewportDataSetMetadataProvider;
